import { Component, inject } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { SkModalContentComponent } from '@ngx-strakit/cdk';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-version-mismatch-dialog',
  templateUrl: './version-mismatch-dialog.component.html',
  imports: [MatDialogModule, MatButtonModule, SkModalContentComponent, TranslatePipe],
})
export class VersionMismatchDialogComponent {
  public dialogRef = inject<MatDialogRef<VersionMismatchDialogComponent>>(MatDialogRef);

  reloadPage(): void {
    this.dialogRef.close(true);
  }
}
